(function(window, angular){'use strict';

var ngModule = angular.module('pp.ui.services.investment-access-guard-dialog', [
    'pp.services.core',
    'pp.services.dialog',
    'pp.services.investor',
    'pp.widgets.investment-investor-blocked-dialog'
]);

/**
 * @ndgoc service
 * @description
 * Displays a modal with the contents of `styleguide/widgets/_angular/extra-user-data`.
 */
ngModule.service('investmentAccessGuardDialogService', ['$rootScope', '$timeout', '$q', 'ppTrack', 'dialogService', 'investorService', 'preferenceService', function ($rootScope, $timeout, $q, ppTrack, dialogService, investorService, preferenceService) {

    // -- initial state

    var promiseCache;

    // -- util functions

    // create a scope, show the dialog
    // tracks dialog dismissed and sets the preference to never show the dialog again (for this scheme)
    function showBlockedDialog(isShariaBlock) {

        ppTrack.action('nationality-lei.dialog.show');

        var scope = $rootScope.$new();

        var options = {
            clickClose: false,
            escapeClose: false,
            showClose: false,
            classNames: 'pp-nationality-lei-dialog',
            scope: scope
        };

        if (isShariaBlock) {
            options.contents = '<pp-investment-sharia-investor-blocked-dialog></pp-investment-sharia-investor-blocked-dialog>';
        } else {
            options.contents = '<pp-investment-investor-blocked-dialog></pp-investment-investor-blocked-dialog>';
        }

        return dialogService.show(options).then(function (response) {
            return $q.reject();
        });
    }

    // -- api

    var api = {};

    api.checkAccess = function (property) {
        if (!property.isVisibleToShareholdersOnly) {
            return $q.when();
        }

        return $q.all({
            unitsHeld: investorService.getInvestorPropertyUnits(false, property.symbol),
            isInvestorAllowedToViewRestrictedInvestment: preferenceService.isInvestorAllowedToViewRestrictedInvestment(property.symbol),
            isUserShariaCompliant: preferenceService.isUserShariaCompliant()
        }).then(function (results) {
            if (results.unitsHeld > 0 || results.isInvestorAllowedToViewRestrictedInvestment) {
                return;
            } else {
                return showBlockedDialog();
            }
        });
    };

    api.checkShariaAccess = function (property) {
        if (property.isShariaEligible) {
            return $q.when();
        }

        return $q.all({
            isUserShariaCompliant: preferenceService.isUserShariaCompliant()
        }).then(function (results) {
            if (results.isUserShariaCompliant && !property.isShariaEligible) {
                return showBlockedDialog(true);
            } else {
                return;
            }
        });
    };

    api.close = function () {
        if (promiseCache) {
            dialogService.close();
        }
    };

    return api;
}]);
})(window, window.angular);